export var SearchSnippets;
(function (SearchSnippets) {
    SearchSnippets["LogzioFilterSearchSnippet"] = "logzio-filter-search-snippet";
})(SearchSnippets || (SearchSnippets = {}));
export var SearchSnippetTypes;
(function (SearchSnippetTypes) {
    SearchSnippetTypes["Logs"] = "logs";
    SearchSnippetTypes["Metrics"] = "metrics";
    SearchSnippetTypes["Traces"] = "traces";
})(SearchSnippetTypes || (SearchSnippetTypes = {}));
//# sourceMappingURL=search-snippets.js.map